"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var client_1 = __importDefault(require("./client"));
var JoanTranslationsBackend = /** @class */ (function () {
    function JoanTranslationsBackend() {
        this.type = 'backend';
    }
    /**
     * Initialize client translations from backend.
     */
    JoanTranslationsBackend.prototype.init = function (services, backendOptions) {
        backendOptions = backendOptions || {};
        if (!backendOptions.hasOwnProperty('client')) {
            backendOptions.client = client_1.default.client(process.env.REACT_APP_translationREST).getApi();
        }
        if (!backendOptions.client.hasOwnProperty('get') || !backendOptions.client.hasOwnProperty('post')) {
            throw Error('Client does not support get and post methods!');
        }
        this.instance = backendOptions.client;
        this.services = services;
    };
    /**
     * Read translations from backend.
     */
    JoanTranslationsBackend.prototype.read = function (language, namespace, callback) {
        var _this = this;
        this.instance
            .get('/rest/translations/', {
            params: {
                language: language,
                domain: namespace,
            },
        })
            .then(function (response) {
            callback(null, response.data.catalog);
        })
            .catch(function (error) {
            console.error(error);
            var langData = _this.services.resourceStore.data;
            // In case that backend returns 429 or any other error we need to set default resources as before,
            // otherwise I18N will throw an error and reset language to English.
            if (langData && langData.hasOwnProperty(language) && langData[language].hasOwnProperty(namespace)) {
                callback(null, langData[language][namespace]);
            }
            else {
                // We don't have any languages loaded. I18next should report an error and render default
                // text from html tags. Empty object will trigger retry events with recursive function
                // time * 2, with 5 attempts. Time = 250!
                callback({
                    name: 'I18NextBackend plugin translation fetch error',
                    message: String(error),
                }, {});
            }
        });
    };
    /**
     * Create a new translation for namespace. Language is always
     * ignored because we only allow to store new keys in default
     * language which is en.
     */
    JoanTranslationsBackend.prototype.create = function (languages, namespace, key) {
        this.instance
            .post('/rest/translations/', {
            domain: namespace,
            translation: key,
        })
            .catch(function (error) {
            console.error(error);
        });
    };
    // only used in backends acting as cache layer
    JoanTranslationsBackend.prototype.save = function () {
        console.log('save() is not supported');
    };
    /* Currently we don't support multiple resources loading. */
    JoanTranslationsBackend.prototype.readMulti = function () {
        console.log('readMulti() is not supported');
    };
    return JoanTranslationsBackend;
}());
exports.default = JoanTranslationsBackend;
